import React from "react";
import { Card, CardHeader, CardContent, Grid, FormControlLabel, Switch, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function StatusHighlightSection({ formData, handleSwitch }) {
  const { t } = useTranslation("products");
  return (
    <Card variant="outlined" sx={{ mb: 6 }}>
      <CardHeader
        title={t("form.statusHighlight")}
        sx={{ pb: 0.5, "& .MuiCardHeader-title": { fontSize: 16, fontWeight: 600 } }}
      />
      <CardContent sx={{ pt: 2 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md="auto">
            <FormControlLabel
              control={
                <Switch
                  name="status"
                  checked={Number(formData.status) === 1}
                  onChange={handleSwitch}
                />
              }
              label={
                Number(formData.status) === 1
                  ? t("table.statusActive")
                  : t("table.statusInactive")
              }
            />
          </Grid>
          <Grid item xs={12} md="auto">
            <FormControlLabel
              control={
                <Switch
                  name="destaque"
                  checked={Number(formData.destaque) === 1}
                  onChange={handleSwitch}
                />
              }
              label={t("form.markFeatured")}
            />
          </Grid>
        </Grid>
        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
          {t("form.statusHint")}
        </Typography>
      </CardContent>
    </Card>
  );
}
